import { translateFn } from '../../../../utils/translator.helper';
import { html, TemplateResult, nothing } from 'lit';
import { createRows } from '../../utils';
import { getFormattedDateTime, TimestampFormat } from '@nirvana/shared/time';
import { BaseSpecificDetailsView } from '../../specificDetailViewByType/baseSpecificDetailsView';
import { FindingDetailsPayload, FindingGroup, RelatedFinding } from '../../findingDetails/types';
import { ExpirationStatus, UNAVAILABLE_DATA } from '../../../types';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export class CertificateReportsView extends BaseSpecificDetailsView {
  static getGeneralInfo(findingDetails: FindingDetailsPayload, dependencies: any): TemplateResult {
    const timezone = dependencies.getTimezone();
    const locale = dependencies.getUserLanguage();

    const detailsInfo = [
      {
        label: translateFn('ID'),
        value: findingDetails.certificateId,
      },
      {
        label: translateFn('Issuer name'),
        value: findingDetails.issuerName,
      },
      {
        label: translateFn('Valid from'),
        value: findingDetails.notBefore
          ? getFormattedDateTime(TimestampFormat.EVENTS, findingDetails.notBefore * 1000, timezone, locale)
          : UNAVAILABLE_DATA,
      },
      {
        label: translateFn('Valid until'),
        value: findingDetails.notAfter
          ? getFormattedDateTime(TimestampFormat.EVENTS, findingDetails.notAfter * 1000, timezone, locale)
          : UNAVAILABLE_DATA,
      },
      {
        label: translateFn('Serial number'),
        value: findingDetails.serialNumber,
      },
      {
        label: translateFn('Certificate expiration status'),
        value: findingDetails.expirationStatus
          ? this.stringsTranslator.translateExpirationStatus(findingDetails.expirationStatus)
          : UNAVAILABLE_DATA,
      },
    ];

    const rows = createRows(detailsInfo, UNAVAILABLE_DATA);

    return html`${rows}`;
  }

  static getSubtitle(relatedFindings: FindingGroup): string {
    let expiredCertificates = 0;
    let soonToExpireCertificates = 0;
    for (const finding of relatedFindings.items) {
      if (finding.expirationStatus === ExpirationStatus.EXPIRED) {
        expiredCertificates++;
      } else if (finding.expirationStatus === ExpirationStatus.SOON_TO_EXPIRE) {
        soonToExpireCertificates++;
      }
    }

    return translateFn(
      '{expiredCertificates}/{total} expired certificates, {soonToExpireCertificates}/{total} soon to expire certificates',
      {
        expiredCertificates: expiredCertificates,
        soonToExpireCertificates: soonToExpireCertificates,
        total: relatedFindings.items.length,
      }
    );
  }

  static getRelatedInfo(relatedFinding: RelatedFinding): TemplateResult | typeof nothing {
    return html`
      <gz-text class="finding-detail" fontWeight="${FontWeights.NORMAL}" fontSize="${FontSizes.PARAGRAPH_12}">
        ${this.stringsTranslator.translateExpirationStatus(relatedFinding.expirationStatus)}
      </gz-text>
    `;
  }
}
